export default __webpack_public_path__ + "static/media/signature.5291b6c8.png";